import React from 'react'
import { useRecoilValue } from 'recoil'

import { ModalBody } from 'mailup-web-components'
import { STORE_KEY_LIST } from 'Constants'
import { useStorage } from 'Hooks/'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'

import { modalSchedulingState } from 'Pages/EmailSendingQueueManage/recoil/state/modals'
import PropTypes from 'prop-types'
import { smartPlanningState } from 'Pages/EmailSendingQueueManage/recoil/state/page'
import { MODE_SMART } from 'Constants/index'
import { useIntl } from 'react-intl'

export const PanelContentScheduled = ({ mode }) => {
  const intl = useIntl()
  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values
  const {
    date: scheduleDate,
    timeZoneCode: scheduleTimeZoneCode
  } = useRecoilValue(modalSchedulingState)

  const { smartPlanningDate } = useRecoilValue(smartPlanningState)

  return (
    <>
      <ModalBody>
        <ContentScheduled
          scheduleDate={mode === MODE_SMART ? smartPlanningDate : scheduleDate}
          scheduleTimeZoneCode={
            mode === MODE_SMART
              ? listTimeZoneCode
              : scheduleTimeZoneCode || listTimeZoneCode
          }
          oneRow
          dateDisabled={mode === MODE_SMART}
          hoursDisabled={mode === MODE_SMART}
          minutesDisabled={mode === MODE_SMART}
          timeZoneDisabled={mode === MODE_SMART}
          description={
            mode === MODE_SMART
              ? intl.formatMessage({
                  id: 'Load.QueueStatus.AiPlanningDescription'
                })
              : undefined
          }
        />
      </ModalBody>
    </>
  )
}

PanelContentScheduled.propTypes = {
  mode: PropTypes.string
}
